var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useEffect, useState } from 'react';
import { DATE_FORMAT_ISO8601_DATE, formatDate, isDateValid, parseDate } from '@navinc/utils';
import { useField } from 'formik';
import { DateSegmentComponent } from './date-segment-component';
const INVALID_VALUE = '0000-00-00';
const FULL_YEAR_LENGTH = 4;
const toDateValue = (input) => {
    if (!input) {
        return '';
    }
    const parsed = parseDate(input);
    if (!isDateValid(parsed)) {
        return INVALID_VALUE;
    }
    return formatDate(parsed, DATE_FORMAT_ISO8601_DATE);
};
const toDateDisplay = (input) => {
    const parsed = parseDate(input);
    if (!isDateValid(parsed)) {
        return '';
    }
    return formatDate(parsed, DATE_FORMAT_ISO8601_DATE);
};
const resolveValue = (input) => {
    if (!input.length || input === '--') {
        return '';
    }
    const [year] = input.split('-');
    return year.length === FULL_YEAR_LENGTH ? toDateValue(input) : INVALID_VALUE;
};
const createDateValidator = ({ isRequired = false, requiredErrorMessage = 'Required', invalidErrorMessage = 'Please enter a valid date' } = {}) => (date) => {
    if (isRequired && !date) {
        return [requiredErrorMessage];
    }
    if (date === INVALID_VALUE) {
        return [invalidErrorMessage];
    }
};
export const DateSegmentInput = (_a) => {
    var { name, onBlur, onChange, invalidOnTouched = true, isRequired, requiredErrorMessage, invalidErrorMessage } = _a, props = __rest(_a, ["name", "onBlur", "onChange", "invalidOnTouched", "isRequired", "requiredErrorMessage", "invalidErrorMessage"]);
    const memoizedValidateDate = useMemo(() => createDateValidator({ isRequired, requiredErrorMessage, invalidErrorMessage }), [isRequired, requiredErrorMessage, invalidErrorMessage]);
    const [field, meta, { setValue }] = useField({ name, validate: memoizedValidateDate });
    const [rawValue, setRawValue] = useState(() => toDateDisplay(field.value));
    useEffect(() => {
        const converted = toDateValue(field.value);
        if (converted !== field.value) {
            // Ensure initial value stored in parent form is formatted correctly
            setValue(converted);
        }
    }, [field.value, setValue]);
    return (_jsx(DateSegmentComponent, Object.assign({ value: rawValue, onChange: (value) => {
            setRawValue(value);
            setValue(resolveValue(value));
            onChange && onChange(value);
        }, onBlur: () => {
            field.onBlur({ target: { name } });
            onBlur && onBlur();
        }, errors: !invalidOnTouched || meta.touched ? meta.error : undefined, isInvalid: (!invalidOnTouched || meta.touched) && !!meta.error, hasSpaceForErrors: true }, props)));
};
//# sourceMappingURL=date-segment-input.js.map